/** @jsxImportSource theme-ui */
import shuffle from "lodash/shuffle";
import React from "react";
import { FragmentType, graphql, useFragment } from "~/gql";
// import SEO from "../seo.jsx";
import LandingPageSections from "./LandingPageSections.next";
import { Box } from "@bottlebooks/gatsby-design-system";

const fragment = graphql(`
  fragment LandingPage on Event {
    ...LandingPageSections
  }

  fragment LandingPage_FeaturedExhibitors on Registration {
    ...LandingPageSections_FeaturedExhibitors
  }

  # fragment LandingPage_LocaleConfig on LocaleConfig {
  #   ...LandingPageSections
  # }
`);

export default function LandingPage({
  event: data,
  localeConfig,
  exhibitors,
  producers,
  location,
  segments,
  locale,
  withOverlay,
  displayedFeaturedExhibitors,
}: {
  event: FragmentType<typeof fragment>;
  localeConfig: any;
  exhibitors: any;
  producers: any;
  location: any;
  segments: any;
  locale: string;
  withOverlay: boolean;
  displayedFeaturedExhibitors: number;
}) {
  const event = useFragment(fragment, data);
  const shuffledExhibitors = React.useMemo(
    () => shuffle(exhibitors).slice(0, displayedFeaturedExhibitors),
    [displayedFeaturedExhibitors, exhibitors]
  );
  const shuffledProducers = React.useMemo(
    () => shuffle(producers).slice(0, displayedFeaturedExhibitors),
    [displayedFeaturedExhibitors, producers]
  );
  return (
    <Box>
      {/* <SEO page={{ path: location.href }} /> */}
      <LandingPageSections
        event={event}
        localeConfig={localeConfig}
        videos={event.videos}
        files={event.files?.nodes}
        locale={locale}
        segments={segments}
        shuffledExhibitors={shuffledExhibitors}
        shuffledProducers={shuffledProducers}
        withOverlay={withOverlay}
      />
    </Box>
  );
}
